export default "https://cdn-static.gokick.com/assets/1d764bbda6f1db3d5ed96a1ece7edd078534d524/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";